import React from 'react';

//material-ui
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';

import { Switch, Route, Redirect } from 'react-router-dom';
// komponen halaman pengguna
import Pengguna from './pengguna';
import Komisi from './komisi';
import Sales from './sale';
// styles
import useStyles from './styles';

function Pengaturan(props) {

    const { location, history } = props;
    const classes = useStyles();
    const handleChangeTab = (event, value) => {

        history.push(value);
    }

    return (
        <Paper square>
            <Tabs
                value={location.pathname}
                indicatorColor="primary"
                textColor="primary"
                onChange={handleChangeTab}
            >
                <Tab label="Orders" value="/admin/order" />
                <Tab label="Komisi" value="/admin/komisi" />
                <Tab label="Sales" value="/admin/sales" />
            </Tabs>
            <div className={classes.tabContent}>
                <Switch>
                    <Route path="/admin/order" component={Pengguna} />
                    <Route path="/admin/sales" component={Sales} />
                    <Route path="/admin/komisi" component={Komisi} />
                    <Redirect to="/admin/order" />
                </Switch>
            </div>
        </Paper>
    )
}

export default Pengaturan;